import { AbstractControl } from '@angular/forms';

/**
 * When the field holds a masked backend value, any edit attempt clears it so the
 * user must retype the entire value. Navigation / select / copy keys are ignored.
 */
export function clearMaskedFieldOnKeydown(
  control: AbstractControl | null | undefined,
  event: KeyboardEvent,
  isMasked: (value: unknown) => boolean
): void {
  if (!control || !isMasked(control.value)) {
    return;
  }

  const navigationKeys = [
    'Tab',
    'Escape',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
  ];
  if (navigationKeys.includes(event.key)) {
    return;
  }

  if (event.ctrlKey || event.metaKey) {
    if (['a', 'c', 'A', 'C'].includes(event.key)) {
      return;
    }
    // Cut / paste: clear and let the browser event continue on the empty field
    if (['x', 'X', 'v', 'V'].includes(event.key)) {
      control.setValue('');
    }
    return;
  }

  control.setValue('');

  if (/^\d$/.test(event.key)) {
    event.preventDefault();
    control.setValue(event.key);
    return;
  }

  if (event.key === 'Backspace' || event.key === 'Delete' || event.key.length === 1) {
    event.preventDefault();
  }
}

export function clearMaskedFieldOnPaste(
  control: AbstractControl | null | undefined,
  isMasked: (value: unknown) => boolean,
  _event?: ClipboardEvent
): void {
  if (!control || !isMasked(control.value)) {
    return;
  }
  control.setValue('');
}
